"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(_ref) {
  var hideCloseButton = _ref.hideCloseButton,
    hasHeader = _ref.hasHeader;
  return {
    padding: !hideCloseButton || hasHeader ? 4 : 2,
    fontSize: 'xl',
    fontWeight: 'semibold',
    // If just close button, still have 'header' section at top
    minHeight: hasHeader || hideCloseButton ? null : 12
  };
};